import { render } from "./onboarding-step.vue?vue&type=template&id=45da43a0&scoped=true"
import script from "./onboarding-step.vue?vue&type=script&lang=js"
export * from "./onboarding-step.vue?vue&type=script&lang=js"

import "./onboarding-step.vue?vue&type=style&index=0&id=45da43a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45da43a0"]])

export default __exports__